import { useMediaQuery } from "@mui/material";
import Product from "./Product";
import MobileMain from "../components/Mobile-View/MobileMain";

const Main = () => {
  const isMobileOrTablet = useMediaQuery("(max-width: 900px)");

  return isMobileOrTablet ? <MobileMain /> : <Product />;
};

export default Main;
